import { FC } from "react";
import { FormInput, formStyles } from "shared/ui";
import type { RaffleSearch } from "../model/useRaffleSearch";

import styles from "./RaffleSearchInput.module.css";

interface Props {
  search: RaffleSearch;
}

export const RaffleSearchInput: FC<Props> = ({ search }) => (
  <form
    className={styles.search}
    role="search"
    onSubmit={(event) => {
      event.preventDefault();
      search.submit();
    }}
  >
    <div className={styles.input}>
      <FormInput
        placeholder="Promo ID"
        aria-label="Search promos"
        maxLength={64}
        value={search.query}
        onValueChange={search.setQuery}
      />
    </div>
    <button
      type="submit"
      className={`${formStyles.outlineButton} ${styles.submit}`}
      disabled={!search.query.trim() || search.isSearching}
    >
      {search.isSearching ? "Searching..." : "Search"}
    </button>
    {search.isActive && (
      <button
        type="button"
        className={formStyles.outlineButton}
        onClick={search.clear}
      >
        Clear
      </button>
    )}
  </form>
);
